import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga4';

const gaCode = [{
    trackingId: 'G-VTC4ZWS7H7'
  },
  {
    trackingId: 'G-F00L7565K2'
  }];
ReactGA.initialize(gaCode);

let environment;

if (window.location.href.includes('dev')) {
  environment = 'dev';
} else if (window.location.href.includes('qa')) {
  environment = 'qa';
} else if (window.location.href.includes('localhost')) {
  environment = 'localhost';
} else {
  environment = 'production';
}

const removeTrailingSlash = urlString => {
  if (urlString.slice(-1) !== '/') return urlString;
  return urlString.slice(0, -1);
}

export const withTracker = (WrappedComponent, props, options = {}) => {
  const trackPage = (page) => {
    ReactGA.send({
      hitType: 'pageview',
      page: page,
      location: removeTrailingSlash(`${window.location.origin}${window.location.pathname}${window.location.search}`),
      ...options,
    });
  };

  const HOC = class extends Component {
    componentDidMount() {
      let page = removeTrailingSlash(window.location.pathname);
      /*
        need to use this array because of how the routes are mapped,
        changing that will cause issues with distribution of prod files via cloudfront
       */
      if (['','/priorauth/index.html', '/priorauth', '/index.html'].includes(page)) page = '/priorauth';
      trackPage(page);
    }

    componentWillReceiveProps(nextProps) {
      const currentPage = removeTrailingSlash(this.props.location.pathname);
      const nextPage = removeTrailingSlash(nextProps.location.pathname);

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...props} />;
    }
  };
  HOC.propTypes = {
    location: PropTypes.object.isRequired,
  };
  return HOC;
};

export const trackEvent = (category, action, label) => {
  ReactGA.initialize(gaCode, {
    gaOptions: { cookieDomain: 'auto' },
  });
  ReactGA.event({
    category: category || null,
    action: action || null,
    label: label || environment,
  });
};
